"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linesWrapper = exports.itemsWrapper = exports.container = void 0;

var _util = require("../../../util");

const ICON_HEIGHT = 16;
const ITEM_INDENT = 8;

const container = ({
  theme,
  cssProps: {
    isActive = false
  }
}) => ({
  cursor: 'pointer',
  transition: 'background 0.2s ease',
  ':hover': {
    background: (0, _util.color)(theme, 'interactive.row.hover')
  },
  ...(isActive && {
    background: (0, _util.color)(theme, 'interactive.row.hover')
  })
});

exports.container = container;

const itemsWrapper = ({
  theme
}) => ({
  position: 'relative',
  flexDirection: 'column',
  marginTop: (0, _util.spacing)(theme, 'large')
});

exports.itemsWrapper = itemsWrapper;

const linesWrapper = ({
  theme
}) => ({
  position: 'absolute',
  height: "calc(100% - ".concat(ICON_HEIGHT * 2, "px - ").concat(ITEM_INDENT, "px)"),
  top: "calc(".concat(ITEM_INDENT, "px + ").concat(ICON_HEIGHT, "px)"),
  flexDirection: 'column',
  alignItems: 'flex-end',
  width: '15px',
  '& > *': {
    width: "".concat(ITEM_INDENT, "px"),
    borderBottom: "2px dotted ".concat((0, _util.color)(theme, 'ui3'))
  },
  '& :first-child': {
    height: "calc(50% - ".concat(ITEM_INDENT, "px)"),
    borderLeft: "2px solid ".concat((0, _util.color)(theme, 'ui3'))
  },
  '& :nth-child(n+2)': {
    height: 'calc(50% + 2px)',
    borderLeft: "2px dotted ".concat((0, _util.color)(theme, 'ui3')),
    marginTop: (0, _util.spacing)(theme, 'xxxsmall')
  }
});

exports.linesWrapper = linesWrapper;
//# sourceMappingURL=ConditionalOrder.style.js.map